// frontend/packages/business-console/src/hooks/useMobileDetect.js
//
// Detects mobile viewport using MUI's useMediaQuery.
// Returns { isMobile } for conditional rendering of
// MobileEditorPane vs EditorPane.
//
// Usage in ContentEditor:
//   const { isMobile } = useMobileDetect();
//   return isMobile ? <MobileEditorPane {...props} /> : <EditorPane {...props} />;

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function useMobileDetect() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return { isMobile };
}
